import { createLivePreviewRequestHandler } from "src/utils/livePreviewHandler";

const fetchEgdGameDoc = createLivePreviewRequestHandler(
  ({ serverURL, apiPath, docId }) => `${serverURL}${apiPath}/egd-games/${docId}?depth=1`
);

/**
 * Live preview request handler for `egd-games` (no drafts on this collection).
 * Payload may return a relation id for `imageMedia`; hydrate it once so
 * preview always has a resolved media doc, same as the built hub data.
 *
 * @param {import('@payloadcms/live-preview').CollectionPopulationRequestHandlerArgs} args
 */
export async function egdLivePreviewRequestHandler(args) {
  const { apiPath, serverURL } = args;
  const response = await fetchEgdGameDoc(args);

  if (!response.ok) return response;

  let doc;
  try {
    doc = await response.json();
  } catch {
    return response;
  }

  // Payload may return relation IDs for imageMedia; hydrate once for reliable preview paths.
  if (doc && (typeof doc.imageMedia === "number" || typeof doc.imageMedia === "string")) {
    const mediaId = String(doc.imageMedia).trim();
    if (mediaId) {
      try {
        const mediaResponse = await fetch(`${serverURL}${apiPath}/media/${mediaId}?depth=0`);
        if (mediaResponse.ok) {
          doc.imageMedia = await mediaResponse.json();
        }
      } catch {
        // Keep original doc if media hydration fails.
      }
    }
  }

  return new Response(JSON.stringify(doc), {
    status: 200,
    headers: { "Content-Type": "application/json" },
  });
}
